import { useJobStore } from "../../../store/Jobs";
import { Logger } from "../../../../../lib/logger/Logger";
import { useTableNavigation } from "../table-navigation-context";

interface UseBulkChangeParams {
	dataItem: any;
	dataIndex?: number;
	field?: string;
	onChange?: (event: any) => void;
}

export const useBulkChange = ({ dataItem, dataIndex, field, onChange }: UseBulkChangeParams) => {
	const { processedItems } = useTableNavigation();
	const { bulkChangeJobItems } = useJobStore((state) => ({
		bulkChangeJobItems: state.bulkChangeJobItems,
	}));

	const handleChange = (
		value: any,
		metaKeyPressed: boolean = false,
		shiftKeyPressed: boolean = false,
		altKeyPressed: boolean = false
	) => {
		if (!onChange) return;

		Logger.log("useBulkChange", "handleChange", value, "metaKey:", metaKeyPressed, "shiftKey:", shiftKeyPressed, "altKey:", altKeyPressed);

		if ((metaKeyPressed || shiftKeyPressed || altKeyPressed) && field) {
			const jobDocumentId = dataItem.job_document_id;

			const allItems = processedItems.some(item => Array.isArray(item.items))
				? processedItems.flatMap(group => group.items || [])
				: processedItems;

			const jobItems = allItems.filter(item => item.job_document_id === jobDocumentId);

			const currentIndex = jobItems.findIndex(item => item.id === dataItem.id);
			const fieldName = field;
			const currentItemType = dataItem.type;

			if (currentIndex >= 0) {
				let itemsToUpdate;

				if (altKeyPressed) {
					itemsToUpdate = jobItems;
				} else if (shiftKeyPressed) {
					const priorAndCurrentItems = jobItems.slice(0, currentIndex + 1);
					itemsToUpdate = priorAndCurrentItems;
				} else {
					const currentAndSubsequentItems = jobItems.slice(currentIndex);
					itemsToUpdate = currentAndSubsequentItems;
				}

				itemsToUpdate = itemsToUpdate.filter(item => item.type === currentItemType);

				const updatedItems = itemsToUpdate.map((item) => ({
					...item,
					[fieldName]: value,
				}));

				bulkChangeJobItems(updatedItems, jobDocumentId);
			}
		} else {
			if (field && dataItem[field] === value) {
				Logger.log("useBulkChange", "No change detected for single item, skipping update");
				return;
			}

			onChange({
				dataItem: dataItem,
				field: field,
				value: value,
				syntheticEvent: value as unknown as React.ChangeEvent<Element>,
				dataIndex: dataIndex,
			});
		}
	};

	return { handleChange };
};
